import { render, staticRenderFns } from "./TargetDefinition.vue?vue&type=template&id=48ab90b0&scoped=true&"
import script from "./TargetDefinition.vue?vue&type=script&lang=js&"
export * from "./TargetDefinition.vue?vue&type=script&lang=js&"
import style0 from "./TargetDefinition.vue?vue&type=style&index=0&id=48ab90b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab90b0",
  null
  
)

export default component.exports